module.exports = __webpack_public_path__ + "img/MARATHON.86e73ad2.svg";